import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Valitse aloituspakettisi <br/> Me hoidamme kaiken, <underline>SINÄ</underline> rentoudu 🚀',
  billing_modes: {
    [BillingMode.InternalInvoicing]: 'Maksa myöhemmin myynnistä',
    [BillingMode.Stripe]: '(0)[Maksa nyt];(1-inf)[Maksa nyt (säästä jopa {{discount}})]',
  },
};
